export type InterviewOccupancy = {
  admins: {
    adminId: number;
    groups: OccupancyEventGroup[];
    /**
     * @deprecated The key should not be used. Will be removed from backend soon.
     */
    team: boolean;
  }[];
  meetingRooms: {
    groups: OccupancyEventGroup[];
    meetingRoomId: number;
  }[];
  date: string;
  team: {
    groups: OccupancyEventGroup[];
  };
};

export type OccupancyEventGroup = {
  allDay: boolean;
  duration: number;
  endsAt: string;
  events: OccupancyEvent[];
  startsAt: string;
};

export type OccupancyEvent = {
  adminId: number;
  allDay: boolean;
  busy: boolean;
  duration: number;
  endsAt: string;
  id: number;
  internal: boolean;
  kind: 'room' | 'my' | 'recruitee';
  roomId: number | null;
  startsAt: string;
  title: string;
};

export enum InterviewOccupancyContext {
  MeetingRoom = 'MeetingRoom',
  Admin = 'Admin',
}
